import { useTranslation } from "react-i18next";
import { Switch } from "shared/components";
import { SwitchWrapper, SwitchLabel } from "../TriggerSettingsFormStyles";
import {
  useActivationPopupsExperimentalTemplatesConfiguration,
  useEnableActivationPopupsExperimentalTemplatesConfiguration,
  useDisableActivationPopupsExperimentalTemplatesConfiguration
} from "../../hooks";
import Container from "../../../../legacy/components/UpCustomerSettingsContainer";
import { useCallback } from "react";

export const ActivationPopupsAdministrationBlock = () => {
  const { t } = useTranslation();

  const { enabled, loading } = useActivationPopupsExperimentalTemplatesConfiguration();

  const enable = useEnableActivationPopupsExperimentalTemplatesConfiguration();

  const disable = useDisableActivationPopupsExperimentalTemplatesConfiguration();

  const handleSwitchClick = useCallback(() => {
    if (enabled) {
      disable();
    } else {
      enable();
    }
  }, [enabled, enable, disable]);

  return (
    <Container
      headline={t("featuresModule.activationPopups.administrationBlock.heading")}
      recommendation={t("featuresModule.activationPopups.administrationBlock.description")}
    >
      <SwitchWrapper>
        <Switch disabled={loading} checked={enabled} onClick={handleSwitchClick} />
        <SwitchLabel>
          {t("featuresModule.activationPopups.administrationBlock.switchLabel")}
        </SwitchLabel>
      </SwitchWrapper>
    </Container>
  );
};
